if (!customElements.get('bundle-pricing')) {
  customElements.define(
    'bundle-pricing',
    class BundlePricing extends HTMLElement {
      quantityUpdateUnsubscriber = undefined;

      constructor() {
        super();
        this.addEventListener('click', this.onOptionClick.bind(this));
      }

      connectedCallback() {
        // Product-info.js resets the quantity input to its minimum on every
        // variant change (e.g. picking a different color) and after every
        // cart update, without knowing about this widget's selection. Stay
        // in sync so the visible selection never lies about what will
        // actually be added to the cart.
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.syncSelectionFromInput.bind(this));
        }
      }

      disconnectedCallback() {
        this.quantityUpdateUnsubscriber?.();
      }

      onOptionClick(event) {
        const option = event.target.closest('.bundle-pricing__option');
        if (!option || !this.contains(option)) return;

        const input = document.getElementById(this.dataset.quantityInput);
        if (!input) return;
        input.value = option.dataset.qty;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.dispatchEvent(new Event('input', { bubbles: true }));

        this.syncSelectionFromInput();
      }

      syncSelectionFromInput() {
        const input = document.getElementById(this.dataset.quantityInput);
        if (!input) return;

        const options = this.querySelectorAll('.bundle-pricing__option');
        let matched = false;
        options.forEach((el) => {
          const isMatch = el.dataset.qty === input.value;
          el.classList.toggle('is-selected', isMatch);
          el.setAttribute('aria-pressed', isMatch ? 'true' : 'false');
          if (isMatch) matched = true;
        });

        // Quantity was reset to something none of the tiers represent
        // (e.g. variant change clamped it) — fall back to the single-unit
        // option so the UI doesn't show a stale selection.
        if (!matched && options.length) {
          options.forEach((el, index) => {
            el.classList.toggle('is-selected', index === 0);
            el.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');
          });
        }
      }
    }
  );
}
